import { sepAPI } from '../API';
import { setSnackbarForEndpoint } from '../../utils/snackbar';
import {
  CommentExtended,
  CreateCommentBody,
} from '../../../shared/types/Comment';

export const commentSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    createComment: builder.mutation<CommentExtended, CreateCommentBody & { suppressSnackbar?: boolean }>({
      query: ({ suppressSnackbar, ...body }) => {
        return {
          url: `comment`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['Comments', 'SEPs'],
      onQueryStarted: (arg, api) => {
        if (!(arg as any).suppressSnackbar) {
          setSnackbarForEndpoint(api, {
            successMessage: 'Your comment has been posted.',
            errorMessage: 'There was a problem posting your comment.',
          });
        }
      },
    }),
    deleteComment: builder.mutation<void, number>({
      query: (id) => {
        return {
          url: `comment/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Comments'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: 'Your comment has been deleted.',
          errorMessage: 'There was a problem deleting your comment.',
        });
      },
    }),
    editComment: builder.mutation<
      CommentExtended,
      { id: number; comment: string; departmentID?: number | null }
    >({
      query: (arg) => {
        return {
          url: `comment/${arg.id}`,
          method: 'PATCH',
          body: {
            comment: arg.comment,
            ...(arg.departmentID !== undefined && {
              departmentID: arg.departmentID,
            }),
          },
        };
      },
      invalidatesTags: ['Comments'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: 'Your comment has been updated successfully.',
          errorMessage: 'There was a problem editing your comment.',
        });
      },
    }),
    getComments: builder.query<CommentExtended[], number>({
      query: (id) => `sep/${id}/comments`,
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Comments' as const, id })),
              'Comments',
            ]
          : ['Comments'],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          errorMessage: 'There was a problem getting the comments.',
        });
      },
    }),
    updateUserReadComment: builder.mutation<void, number>({
      query: (IDs) => ({
        url: `user-comment-read`,
        method: 'POST',
        body: [IDs],
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'Comments', id: arg }],
    }),
  }),
});

export const {
  useCreateCommentMutation,
  useGetCommentsQuery,
  useDeleteCommentMutation,
  useEditCommentMutation,
  useUpdateUserReadCommentMutation,
} = commentSlice;
